const initialState = {
    str: ''
}

const passportExpiresRed = (state = initialState, action) => {
    switch(action.type){
        case 'PASSPORT_EXPIRES' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default passportExpiresRed